import React from "react"




import { ReactFC } from "types"


import { useCircleMembership } from "circle/circle.selectors"
import { useProfile } from "profile"
import { ArticleSummaryProps, ArticleSummaryCore2 } from "lib-core"


const ArticleSummary: ReactFC<ArticleSummaryProps> = (props) => {
  const membership = useCircleMembership()
  const profile = useProfile().profile

  return <ArticleSummaryCore2 membership={membership} profile={profile} {...props}/>
}

export default ArticleSummary
